  /* eslint-disable @typescript-eslint/no-explicit-any */
  import { ApiError } from "../../types/ApiError";
  import { axios } from "../../lib/axios";
  import { MetaData } from "../Courses/GetAllRequests";
  export type CustomQuiz = {
    id: string;
    score: string;
    status: string;
    num_tries: string;
    message: string;
    createdAt: string;
    quiz: {
      id: string;
      title: string;
    };
    quizId: string;
  };
  
  interface CustomQuizzesData {
    quizzes: CustomQuiz[];
    count: number;
    metaData: MetaData;
  }
  
  interface CustomQuizzesResponse {
    data?: CustomQuizzesData;
    error?: ApiError;
  }
  
  interface GetCustomQuizzesParams {
    page: number;
    limit: number;
  }
  
  export const getMyCustomQuizzes = async ({
    page,
    limit,
  }: GetCustomQuizzesParams): Promise<CustomQuizzesResponse> => {
    try {
      const response = await axios.get(`/certificate-exam/my-custom-quizzes`, {
        params: { page, limit },
      });
      return { data: response.data.data };
    } catch (error: any) {
      console.error("API Error:", error);
      if (error.response) {
        const apiError: ApiError = {
          statusCode: error.response.status,
          message: error.response.data.message,
          error: error.response.data.error,
        };
        return { error: apiError };
      } else {
        const fallbackError: ApiError = {
          statusCode: 500,
          message: "An unexpected error occurred",
        };
        return { error: fallbackError };
      }
    }
  };
  